import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useTheme } from '../context/ThemeContext';
import './Layout.css';

const Layout = ({ children }) => {
  const { user, logout } = useAuth();
  const { darkMode, toggleTheme } = useTheme();
  const location = useLocation();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  
  const getInitials = (name) => {
    if (!name) return 'FT';
    const parts = name.split(' ');
    return (parts[0]?.[0] || '') + (parts[1]?.[0] || '');
  };

  const navItems = [
    { path: '/', label: 'Marketing', icon: '📊' },
    { path: '/calendar', label: 'Calendrier Contenu', icon: '📅' },
    { path: '/transformations', label: 'Transformations', icon: '💰' },
    { path: '/relances', label: 'Relances Sheet', icon: '🔔' },
    { path: '/whatsapp', label: 'Clients WA', icon: '💬' },
    { path: '/absences', label: 'Absences', icon: '📅' },
    { path: '/settings', label: 'Parametres', icon: '⚙️' }
  ];

  const closeSidebar = () => setSidebarOpen(false);

  return (
    <div className="layout">
      <div className={`sidebar-overlay ${sidebarOpen ? 'active' : ''}`} onClick={closeSidebar} />
      <aside className={`sidebar ${sidebarOpen ? 'open' : ''}`}>
        <div className="sidebar-logo">
          <div className="logo">TGG</div>
          <div>
            <div className="brand-name">TeamGreekGods</div>
            <div className="brand-sub">Dashboard Assistante</div>
          </div>
        </div>
        
        <div className="sidebar-user">
          <div className="avatar">{getInitials(user?.name)}</div>
          <div>
            <div className="user-name">{user?.name || 'User'}</div>
            <div className="user-role">{user?.role || 'Assistante'}</div>
          </div>
          <div className="online-dot"></div>
        </div>

        <nav className="sidebar-nav">
          <div className="nav-section">Principal</div>
          {navItems.slice(0, 3).map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${location.pathname === item.path ? 'active' : ''}`}
              onClick={closeSidebar}
            >
              <span className="nav-icon">{item.icon}</span>
              {item.label}
            </Link>
          ))}
          
          <div className="nav-section">Leads</div>
          <Link
            to="/relances"
            className={`nav-item ${location.pathname === '/relances' ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">🔔</span>
            Relances Sheet
          </Link>
          
          <div className="nav-section">Equipe</div>
          <Link
            to="/whatsapp"
            className={`nav-item ${location.pathname === '/whatsapp' ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">💬</span>
            Clients WA
          </Link>
          <Link
            to="/absences"
            className={`nav-item ${location.pathname === '/absences' ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">📅</span>
            Absences
          </Link>
          
          <div className="nav-section">Config</div>
          <Link
            to="/settings"
            className={`nav-item ${location.pathname === '/settings' ? 'active' : ''}`}
            onClick={closeSidebar}
          >
            <span className="nav-icon">⚙️</span>
            Parametres
          </Link>
        </nav>

        <button className="theme-toggle" onClick={toggleTheme}>
          <span className="theme-icon">{darkMode ? '☀️' : '🌙'}</span>
          <span className="theme-label">{darkMode ? 'Mode Clair' : 'Mode Sombre'}</span>
        </button>
      </aside>

      <main className="main-content">
        <header className="header">
          <button className="menu-toggle" onClick={() => setSidebarOpen(true)}>
            <span>&#9776;</span>
          </button>
          <div className="header-title">{document.title}</div>
          <div className="header-right">
            <span className="header-date" id="header-date"></span>
            <span className="header-time" id="header-time"></span>
            <button onClick={logout} className="logout-btn">Deconnexion</button>
          </div>
        </header>
        <div className="content">{children}</div>
      </main>
    </div>
  );
};

export default Layout;
